import { conversionImages } from './mockData';

export const brandSeoPages = {
  bambuLab: {
    slug: 'bambu-lab',
    path: '/bambu-lab-repair-australia',
    canonical: 'https://repair.3dprintergear.com.au/bambu-lab-repair-australia',
    title: 'Bambu Lab Repair Australia | X1 Carbon, P1S, A1 & AMS Service',
    description: 'Bambu Lab repair support Australia-wide for X1 Carbon, P1S, P1P, A1, A1 Mini and AMS issues. Hotend, extrusion, filament feed and calibration repairs with free quote before work begins.',
    image: conversionImages.heroRepairTechnician,
    brandName: 'Bambu Lab',
    h1: 'Bambu Lab Repair Australia',
    eyebrow: 'Bambu Lab repair specialists',
    heroSubheading: 'Australia-wide Bambu Lab repair support for X1 Carbon, P1S, P1P, A1, A1 Mini and AMS issues. Start with a repair request, photos and symptoms so our team can guide the right service path.',
    proof: ['X1 Carbon repair support', 'AMS issue triage', 'Fully insured', 'Quote before work begins'],
    prefill: {
      printerBrand: 'bambu-lab',
      issueDescription: 'I need help with a Bambu Lab printer issue.',
      urgency: 'priority'
    },
    models: [
      { model: 'X1 Carbon', focus: 'Hotend, extrusion, lidar/calibration, AMS and print-quality faults' },
      { model: 'X1E', focus: 'Professional workflow diagnostics, extrusion and connectivity support' },
      { model: 'P1S', focus: 'Extrusion, chamber, fan, calibration and filament-path issues' },
      { model: 'P1P', focus: 'Hotend, belt, motion, bed adhesion and print reliability repairs' },
      { model: 'A1', focus: 'Nozzle, calibration, filament feed and bed-level issues' },
      { model: 'A1 Mini', focus: 'Small-format print reliability, extrusion and sensor faults' },
      { model: 'AMS', focus: 'Feed failures, filament loading, buffer, slot and jam troubleshooting' }
    ],
    issues: [
      {
        title: 'Hotend or nozzle clog',
        description: 'Partial clogs, failed extrusion, grinding filament, heat creep and inconsistent flow on X1, P1 and A1 series printers.'
      },
      {
        title: 'Extruder jam or filament stuck',
        description: 'Filament breaks, feed gear issues, clicking, stuck material and repeated loading failures.'
      },
      {
        title: 'AMS feed failure',
        description: 'AMS slot errors, filament not feeding, retraction problems, buffer issues and multi-material reliability faults.'
      },
      {
        title: 'Bed adhesion and calibration',
        description: 'First-layer failures, uneven prints, bed surface problems, calibration failures and repeat print-quality issues.'
      },
      {
        title: 'Sensor, fan or firmware errors',
        description: 'Hardware warnings, fan faults, sensor messages, firmware-related issues and recurring machine errors.'
      },
      {
        title: 'Print-quality diagnostics',
        description: 'Layer shifting, ringing, under-extrusion, blobs, surface defects and failures that return after basic tuning.'
      }
    ],
    workflow: [
      ['Diagnose', 'Submit the printer model, symptoms, photos and urgency so our team can identify the likely fault path.'],
      ['Quote', 'We provide a clear quote before repair work begins, including likely parts or service requirements.'],
      ['Repair', 'Your Bambu printer is handled through the most suitable workflow: remote triage, send-in, repair-centre support or scheduled service.'],
      ['Test print', 'Where practical, repairs are verified with calibration and test-print checks before completion.']
    ],
    faqs: [
      {
        question: 'Do you repair Bambu Lab X1 Carbon printers in Australia?',
        answer: 'Yes. We support Bambu Lab X1 Carbon repairs Australia-wide, including hotend, extrusion, AMS, calibration, sensor and print-quality issues.'
      },
      {
        question: 'Can you help with Bambu Lab AMS problems?',
        answer: 'Yes. We can triage AMS feed failures, filament loading faults, slot issues, buffer problems and recurring multi-material reliability problems.'
      },
      {
        question: 'Do I need to send my Bambu Lab printer in for repair?',
        answer: 'Not always. Start with a repair request and photos. We will advise whether remote triage, send-in repair, repair-centre support or scheduled service is the best path.'
      },
      {
        question: 'Do you repair Bambu Lab P1S, P1P, A1 and A1 Mini printers?',
        answer: 'Yes. We support Bambu Lab X1, P1 and A1 series printers, including common hotend, extrusion, bed adhesion, fan, sensor and calibration issues.'
      },
      {
        question: 'Do you provide a quote before repairing a Bambu Lab printer?',
        answer: 'Yes. We provide a clear quote before repair work begins. The quote depends on the model, symptoms, parts required and service path.'
      }
    ]
  }
};